export const environment = {
  production: false,
  // Trusted Falcon parent origins allowed to exchange postMessage data with this app.
  allowedParentOrigins: [
    'https://futuristic-policy.dev.falconsystem.com',
    'https://policy.dev.falconsystem.com',
    'https://nta.dev.falconsystem.com',
    'https://links.dev.falconsystem.com',
    'http://localhost:4200',
    'http://127.0.0.1:4200',
  ],
  mvrApi: {
    baseUrl: 'https://mvr.dev.falconsystem.com/api/form/v1',
    apiKeyValidationUrl: 'https://mvr.dev.falconsystem.com/api/form/v1/validate-api-key/',
    callbackUrl: 'https://mvr.dev.falconsystem.com/form/local-callback-webhook/',
    includeBbox: true, 
    includeHighlightedPdf: false,
    pollIntervalMs: 8000,
    pollTimeoutMs: 1200000,
  },
};
